import { Button, Modal } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { makeThemedStyles } from "qpr-base/viewcomponents/utils";
import React from "react";

const useDrillDownModalStyles = makeThemedStyles("DrillDownModal", (theme) => ({
  Modal: {
    opacity: "1",
    width: "680px",
    marginTop: "12%",
    marginLeft: "auto",
    marginRight: "auto",
  },
  ModalPaper: {
    minWidth: "680px",
    maxWidth: "680px",
    maxHeight: "60vh",
    marginTop: "5em",
    borderRadius: "4em",
    // overflowY: 'auto',
    overflow: "hidden",
    "-ms-overflow-style": "none",
    scrollbarWidth: "none",
    backdropFilter: "blur(4px)",
    boxShadow: "0px 10px 50px rgba(0,0,0,0.1)",
  },
  closeButton: {
    width: "20px",
    height: "40px",
  },
  closeButtonContainer: {
    marginBottom: "-40px",
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-end",
  },
  closeIcon: {
    width: "30px",
    height: "30px",
    top: "0em",
    position: "absolute",
    backgroundColor: "#FFFFFF",
    borderRadius: "0.3em",
    cursor: "pointer",
  },
}));

type Props = React.PropsWithChildren<{
  isOpen: boolean;
  onClose?: () => void;
  rtl?: boolean;
}>;

const DrillDownModal = (props: Props) => {
  const { onClose, isOpen, rtl } = props;
  const classes = useDrillDownModalStyles();
  return (
    <Modal
      open={isOpen}
      onClose={onClose}
      className={classes.Modal}
      BackdropProps={{ style: { opacity: 0.5, background: "#3377bb" } }}
    >
      <div dir={rtl ? "rtl" : "ltr"}>
        <div className={classes.closeButtonContainer}>
          <Button onClick={props.onClose} className={classes.closeButton}>
            <CloseIcon className={classes.closeIcon} />
          </Button>
        </div>
        <div className={classes.ModalPaper}>{props.children}</div>
      </div>
    </Modal>
  );
};

export default DrillDownModal;
